export const SYSTEM_MENU_THEME = 'DEFAULT_THEME'
export const SYSTEM_COLOR = 'DEFAULT_COLOR'
export const SYSTEM_LAYOUT = 'SYSTEM_LAYOUT'
export const SYSTEM_CONTENT_WIDTH = 'DEFAULT_CONTENT_WIDTH'
export const SYSTEM_FIXED_HEADER = 'DEFAULT_FIXED_HEADER'
export const SYSTEM_FIXED_SIDERBAR = 'DEFAULT_FIXED_SIDERBAR'
export const SYSTEM_AUTOHIDE_HEADER = 'DEFAULT_AUTOHIDE_HEADER'
export const SYSTEM_COLORWEAK = 'SYSTEM_COLORWEAK'

export const ACCESS_TOKEN = 'Authorization'
export const USER = 'USER'

export const MENUS = 'MENUS'

export const SIDEBAR_TYPE = 'SIDEBAR_TYPE'

export const DEFAULT_MULTI_TAB = 'DEFAULT_MULTI_TAB'

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}
